<template>
  <div>
    <div class="slider-item-sm" v-bind:style="headerBanner"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="product-list">
            <li>
              <div class="product product-sm-left">
                <ul class="product-labels"></ul>
                <div class="product-img-wrap2">
                  <img
                    width="70"
                    height="70"
                    v-bind:src="headerInfo.LogoImg"
                    alt="Image Alternative text"
                    title="Image Title"
                  />
                </div>
                <div class="product-img-wrap3">
                  <h5 class="product-caption-title2">{{headerInfo.CompanyName}}</h5>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="tabbable product-tabs">
        <ul class="nav nav-tabs" id="myTab">
          <li v-bind:class="{ 'active': (defaultTab==1)}">
            <a href="#tab-1" data-toggle="tab">
              <i class="fa fa-list nav-tab-icon"></i>Overview
            </a>
          </li>
          <li v-bind:class="{ 'active': (defaultTab==2)}">
            <a href="#tab-2" data-toggle="tab">
              <i class="fa fa-cogs nav-tab-icon"></i>Our Products
            </a>
          </li>
          <li v-bind:class="{ 'active': (defaultTab==3)}">
            <a href="#tab-3" data-toggle="tab">
              <i class="fa fa-star nav-tab-icon"></i>Our Services
            </a>
          </li>
          <li v-bind:class="{ 'active': (defaultTab==4)}">
            <a href="#tab-4" data-toggle="tab">
              <i class="fa fa-comment nav-tab-icon"></i>Contact Us
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            v-bind:class="{ 'tab-pane fade in active': (defaultTab==1), 'tab-pane fade in': (defaultTab!=1)}"
            id="tab-1"
          >
            <table class="table">
              <thead class="widget-title-lg2">
                <tr>
                  <th>General Information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="product-page-features-table-specs">Registration No</td>
                  <td class="product-page-features-table-details2">{{generalInfo.RegistrationNo}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="product-page-features-table-specs">Date Incorporated</td>
                  <td class="product-page-features-table-details2">{{generalInfo.DateIncorporated}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="product-page-features-table-specs">Registered Address</td>
                  <td class="product-page-features-table-details2">{{generalInfo.RegisteredAddress}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="product-page-features-table-specs">Authorized Capital</td>
                  <td class="product-page-features-table-details2">{{generalInfo.AuthorizeCapital}}</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="product-page-features-table-specs">Total Employess</td>
                  <td class="product-page-features-table-details2">{{generalInfo.TotalEmployees}}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p></p>
            <table class="table" v-if="company.branchList && company.branchList.length > 0">
              <thead class="widget-title-lg2">
                <tr>
                  <th>Branch</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="branch in company.branchList">
                  <td class="product-page-features-table-specs">
                    <img
                      width="110"
                      height="110"
                      v-bind:src="branch.BranchImg"
                      alt="Image Alternative text"
                      title="Image Title"
                    />
                  </td>
                  <td class="product-page-features-table-details2">
                    <!-- oleg, below data should be coming from API   -->
                    <p>Name: {{branch.Name}}</p>
                    <p>Type: {{branch.Type}}</p>
                    <p>Location : {{branch.Location}}</p>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p></p>
            <table class="table" v-if="company.corporateList && company.corporateList.length > 0">
              <thead class="widget-title-lg2">
                <tr>
                  <th>Corporate Registration</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="corporate in company.corporateList">
                  <td class="product-page-features-table-specs">
                    <img
                      width="110"
                      height="110"
                      v-bind:src="corporate.CorporateImg"
                      alt="Image Alternative text"
                      title="Image Title"
                    />
                  </td>
                  <td class="product-page-features-table-details2">
                    <!-- oleg, below data should be coming from API   -->
                    <p>{{corporate.CorporateName}}</p>
                    <p></p>
                    <p></p>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p></p>
            <table
              class="table"
              v-if="company.certificateList && company.certificateList.length > 0"
            >
              <thead class="widget-title-lg2">
                <tr>
                  <th>Certifications</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="certificate in company.certificateList">
                  <td class="product-page-features-table-specs">
                    <img
                      width="110"
                      height="110"
                      v-bind:src="certificate.CertificationImg"
                      alt="Image Alternative text"
                      title="Image Title"
                    />
                  </td>
                  <td class="product-page-features-table-details2">
                    <!-- oleg, below data should be coming from API   -->
                    <p>{{certificate.CertName}}</p>
                    <p>Issued by : {{certificate.IssuedBy}}</p>
                    <p>Date Issued: {{certificate.DateIssued}}</p>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <p></p>
            <table class="table" v-if="company.awardList && company.awardList.length > 0">
              <thead class="widget-title-lg2">
                <tr>
                  <th>Awards</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="award in company.awardList">
                  <td class="product-page-features-table-specs">
                    <img
                      width="110"
                      height="110"
                      v-bind:src="award.AwardImg"
                      alt="Image Alternative text"
                      title="Image Title"
                    />
                  </td>
                  <td class="product-page-features-table-details2">
                    <p>{{award.AwardName}}</p>
                    <p>Awarded by : {{award.AwardBy}}</p>
                    <p>Date Issued: {{award.DateAwarded}}</p>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-bind:class="{ 'tab-pane fade in active': (defaultTab==2), 'tab-pane fade in': (defaultTab!=2)}"
            id="tab-2"
          >
            <div class="row">
              <div class="col-md-12">
                <ul class="product-accessory-list">
                  <li v-for="product in productList.productList" class="product-accessory">
                    <div class="row">
                      <div class="col-md-2">
                        <a href="#">
                          <img
                            class="product-accessory-img2"
                            v-bind:src="product.DefaultImage"
                            alt="Image Alternative text"
                            title="Image Title"
                          />
                        </a>
                      </div>
                      <div class="col-md-9">
                        <h5 class="product-caption-title-search">
                          <router-link
                            :to="{ name: 'product', params: { id: product.Id }}"
                          >{{product.Name}}</router-link>
                        </h5>
                        <p
                          class="product-caption-feature-list-title2"
                        >Category : {{product.Category}}</p>
                        <p class="product-caption-feature-list-title3">Description:</p>
                        <p class="product-caption-feature-list-title4">{{product.Description}}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="card-footer pb-0 pt-3"  v-if="rowsProductList>0">
                <paginate
                  :pageCount="totalPageProductList"
                  :containerClass="'pagination'"
                  :clickHandler="onChangePageProductList"
                ></paginate>
              </div>
              <p class="mt-3">Total Records: {{ rowsProductList }}</p>
            </div>
          </div>
          <div
            v-bind:class="{ 'tab-pane fade in active': (defaultTab==3), 'tab-pane fade in': (defaultTab!=3)}"
            id="tab-3"
          >
            <div class="row">
              <div class="col-md-12">
                <ul class="product-accessory-list">
                  <li v-for="service in serviceList.serviceList" class="product-accessory">
                    <div class="row">
                      <div class="col-md-2">
                        <a href="#">
                          <img
                            class="product-accessory-img2"
                            v-bind:src="service.DefaultImage"
                            alt="Image Alternative text"
                            title="Image Title"
                          />
                        </a>
                      </div>
                      <div class="col-md-9">
                        <h5 class="product-caption-title-search">
                          <router-link
                            :to="{ name: 'service', params: { id: service.Id }}"
                          >{{service.Name}}</router-link>
                        </h5>
                        <p
                          class="product-caption-feature-list-title2"
                        >Category : {{service.Category}}</p>
                        <p class="product-caption-feature-list-title3">Description:</p>
                        <p class="product-caption-feature-list-title4">{{service.Description}}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="card-footer pb-0 pt-3" v-if="rowsServiceList>0">
                <paginate
                  :pageCount="totalPageServiceList"
                  :containerClass="'pagination'"
                  :clickHandler="onChangePageServiceList"
                ></paginate>
              </div>
              <p class="mt-3">Total Records: {{ rowsServiceList }}</p>
            </div>
          </div>
          <div
            v-bind:class="{ 'tab-pane fade in active': (defaultTab==4), 'tab-pane fade in': (defaultTab!=4)}"
            id="tab-4"
          >
            <div class="row">
              <div class="col-md-12">
                <h3 class="widget-title">Leave a Message</h3>
                <p
                  class="text-muted"
                >Like what you see in our products and services? Would like to engange with us?</p>
                <p
                  class="text-muted"
                >Fill in the form below and we will answer you as soon as possible</p>
                <form>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Name</label>
                        <input class="form-control" disabled type="text" v-model="name" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>E-mail</label>
                        <input class="form-control" disabled type="text" v-model="email" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Subject</label>
                        <input class="form-control" type="text" v-model="title" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Message</label>
                    <textarea class="form-control"  v-model="message" ></textarea>
                  </div>
                  <!-- <input
                    v-bind:class="{ 'btn btn-primary disabled': !getUser, 'btn btn-primary': getUser}"
                    @click.stop="onSubmit"
                    type="button"
                    value="Send a Message"
                  /> -->
                  <div id="button-container">
                    <input
                      v-bind:class="{ 'btn btn-primary disabled': !getUser, 'btn btn-primary': getUser}"
                      @click.stop="onSubmit"
                      type="button"
                      value="Send a Message"
                    />

                    <div v-bind:class="{ 'btn btn-primary disabled': !getUser, 'btn btn-primary': getUser}" @click="openFileInput">
                      <i class="fa fa-upload mr-1" aria-hidden="true"></i>Upload File (.pdf)
                    </div>
                    <div style="width: 0px; overflow: hidden;">
                      <input type="file" ref="inputFile" class="form-control" 
                        @change="onFileSelect" accept="application/pdf"
                      />
                    </div>
                  </div>
                  
                  <span class="mr-1">{{displayFileName}} </span>
                  <span v-if="attachment !== null" @click="cancelUpload">
                    <i class="fa fa-times-circle" aria-hidden="true" style="cursor:pointer;" title="Cancel Upload"></i>
                  </span>

                  <p v-if="!getUser">
                    <span style="color:red">Please login before submitting your Inquiry</span>
                  </p>
                  <div class="row">
                    <div class="col-md-12 form-group"></div>
                  </div>
                  <div class="row" v-if="error != ''">
                    <div class="col-md-12 form-group">
                      <div class="alert alert-danger">
                        <label>{{error}}</label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gap"></div>
      <div v-if="showLoader" class="modal" id="loading">
        <!--  -->
      <div class="modal-content" id="loading-content">
        <span class="loader"><span class="loader-inner"></span></span>
        <label>Please wait a second!</label>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);

export default {
  data() {
    return {
      defaultTab: this.$route.params.tab || 1,
      name: localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' ? JSON.parse(localStorage.getItem("user")).name : '',
      email: localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' ? JSON.parse(localStorage.getItem("user")).email : '',
      title: this.$route.params.subject || "",
      message: "",
      error: "",
      user: localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' ? JSON.parse(localStorage.getItem("user")) : {},
      showLoader: false,
      attachment: null,
      displayFileName: '',
      fileName: '',
      attachmentUrl: '',
      tenantInquiryId: 0,
      tenantInquiryHistoryId: 0
    };
  },
  created() {
    //console.log('this.$route.params ::::::::::::::::: ', this.$route.params);
    // console.log(
    //   "USER ::::::::::::::::: ",
    //   JSON.parse(localStorage.getItem("user")).email
    // );

    this.$store.dispatch("company/fetchCompany", {
      companyId: this.$route.params.id
    });

    this.initViewProductList(this.$route.params.id, 1);
    this.initViewServiceList(this.$route.params.id, 1);
  },
  computed: {
    ...mapState({
      company: state => state.company.companyDetails,
      productList: state => state.company.companyProductList,
      serviceList: state => state.company.companyServiceList
    }),
    rowsProductList() {
      return this.productList.productListRowCount;
    },
    rowsServiceList() {
      return this.serviceList.serviceListRowCount;
    },
    totalPageProductList() {
      return this.productList.productListRowCount == 0
        ? 0
        : Math.trunc(this.productList.productListRowCount / 10) +
            (this.productList.productListRowCount % 10 > 0 ? 1 : 0);
    },
    totalPageServiceList() {
      return this.serviceList.serviceListRowCount == 0
        ? 0
        : Math.trunc(this.serviceList.serviceListRowCount / 10) +
            (this.serviceList.serviceListRowCount % 10 > 0 ? 1 : 0);
    },
    headerInfo() {
      if (this.company.headerInfo.length > 0) {
        return this.company.headerInfo[0];
      }
      return {};
    },
    headerBanner() {
      return "background-image:url(" + this.headerInfo.BannerImg + ")";
    },
    getUser() {
      //console.log('localStorage USER :::::::::: ', localStorage.getItem("user").id);
      return localStorage.getItem("user") !== null && localStorage.getItem("user") !== 'null' ? true : false;
    },
    generalInfo() {
      if (this.company.generalInfo.length > 0) {
        return this.company.generalInfo[0];
      }

      return {};
    }
  },
  watch: {
    $route(to, from) {
      this.initViewProductList(this.$route.params.id, this.pageOfItemsProduct);
      this.initViewServiceList(this.$route.params.id, this.pageOfItemsService);
    }
  },
  methods: {
    initViewProductList(cid, pn) {
      this.$store.dispatch("company/fetchCompanyProductList", {
        companyId: cid,
        searchKey: "",
        RowsPerPage: 10,
        PageNumber: pn
      });
    },
    initViewServiceList(cid, pn) {
      this.$store.dispatch("company/fetchCompanyServiceList", {
        companyId: cid,
        searchKey: "",
        RowsPerPage: 10,
        PageNumber: pn
      });
    },
    onChangePageProductList(pageOfItemsProduct) {
      this.pageOfItemsProduct = pageOfItemsProduct;
      this.initViewProductList(this.$route.params.id, this.pageOfItemsProduct);
    },
    onChangePageServiceList(pageOfItemsService) {
      this.pageOfItemsService = pageOfItemsService;
      this.initViewServiceList(this.$route.params.id, this.pageOfItemsService);
    },
    async onSubmit() {
      if (this.title == "" || this.title == null) {
        this.error = "Subject is empty";
        return;
      } else if (this.message == "" || this.message == null) {
        this.error = "Message is empty";
        return;
      } else {
        this.error = "";
      }

      const confirmed = await this.$confirm("", "Are you sure to submit your inquiry?");

      if (confirmed) {
        this.showLoader = true;
        if (this.attachment != null) {
          this.fileName = this.displayFileName.split('.')[0];
          const result = await this.$store.dispatch("products/addAttachmentInquiry", { attachment: this.attachment });
          
          this.attachmentUrl = result;
        }

        try {
          const response = await this.$store.dispatch("products/addInquiry", {
            title: "Inquiry : " + this.title,
            toTenantId: this.$route.params.id,
            rfqBody: this.message,
            fromUserId: this.user.id,
            attachmentUrl: this.attachmentUrl,
            fileName: this.fileName,
            
          });

          this.tenantInquiryId = response.data.Item1.Id;
          this.tenantInquiryHistoryId = response.data.Item2;
          // console.log('tenant inquiry id :::: ', this.tenantInquiryId);
          // console.log('tenant inquiry history id :::: ', this.tenantInquiryHistoryId);
          
          await this.$store.dispatch("products/pushInquiryEmail", {
            tenantInquiryId: this.tenantInquiryId,
            tenantInquiryHistoryId: this.tenantInquiryHistoryId
          })

          this.showLoader = false;
        } catch (error) {
          console.error(error);
          this.showLoader = false;
        }
      }
      

      this.$alert(
        "To folow up, please check in 'Qoute Me' module in Dashboard",
        "Inquiry sucessfully send",
        "success"
      ).then(() => {
        // this.$router.push({
        //   name: "company",
        //   params: { id: this.$route.params.id }
        // });

        this.title = "";
        this.message = "";
        this.attachment = null;
        this.attachmentUrl = '';
        this.displayFileName = '';
        this.fileName = '';
        
        this.$store.dispatch("company/fetchCompany", {
          companyId: this.$route.params.id
        });
      });
    },

    openFileInput() {
      this.$refs.inputFile.value = '';
      this.$refs.inputFile.click();
    },

    onFileSelect(event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        this.attachment = file;
        this.displayFileName = file.name;
      }
    },

    cancelUpload() {
      this.$refs.inputFile.value = '';
      this.attachment = null;
      this.displayFileName = '';
    },
  }
};
</script>

<style>

#button-container {
  display: flex;
  gap: 10px;
}
</style>
